import { render, staticRenderFns } from "./AccountsTypesAdd.vue?vue&type=template&id=02890f5d&scoped=true&"
import script from "./AccountsTypesAdd.vue?vue&type=script&lang=js&"
export * from "./AccountsTypesAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02890f5d",
  null
  
)

export default component.exports